export interface ValidationError {
  name?: string;
  message: string;
  type: string;
  regexp?: string;
  value?: string | number;
  checkbox?: boolean;
}
